import { getPriority } from '@esentai/core/features/questions/selectors';
import {
  compose,
  equals,
  head,
  last,
  map,
  max,
  min,
  not,
  pipe,
  reduce,
} from 'ramda';

import { createQuestionEditPageUrl } from '@/features/questionEditPage/utils';

import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export const {
  getError,
  isLoadingItems,
  getItemsIds,
  getItemsMeta,
  getItemsTotalCount,
} = itemsDuck.selectors;

export const { getPage, getLimit, getQuery, getSort } = queryDuck.selectors;

export const isFirstPage = pipe(getPage, equals(0));

export const isLastPage = state => {
  const totalCount = getItemsTotalCount(state);
  const currentOffset = (getPage(state) + 1) * getLimit(state);

  return currentOffset > totalCount;
};

export const isFirstItem = (state, questionId) => {
  const ids = getItemsIds(state);
  const firstItem = head(ids);

  return questionId === firstItem;
};

export const isLastItem = (state, questionId) => {
  const ids = getItemsIds(state);
  const lastItem = last(ids);

  return questionId === lastItem;
};

export const getQuestionEditUrl = (state, questionId) =>
  createQuestionEditPageUrl(questionId);

export const getQuestionsPriorities = state =>
  pipe(
    getItemsIds,
    map(questionId => getPriority(state, questionId)),
  )(state);

export const getHighestPriority = pipe(
  getQuestionsPriorities,
  reduce(min, Infinity),
);

export const getLowestPriority = pipe(
  getQuestionsPriorities,
  reduce(max, -Infinity),
);

export const hasHighestPriority = (state, questionId) => {
  const priority = getPriority(state, questionId);
  const highestPriority = getHighestPriority(state);

  return priority === highestPriority;
};

export const hasLowestPriority = (state, questionId) => {
  const priority = getPriority(state, questionId);
  const lowestPriority = getLowestPriority(state);

  return priority === lowestPriority;
};

export const canMoveQuestionUp = compose(not, isFirstItem);

export const canMoveQuestionDown = compose(not, isLastItem);
